import api from "Common/Client/Interceptor";
import { toArray } from "Common/utils/list";

export const fetchReports = async (memberId, token) => {
  try {
    const response = await api.get(`/TrainingProgressReport/Learner/List?memberId=${memberId}&pageNumber=1&pageSize=30`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    return toArray(response.data)
  } catch (error) {
    console.error('Error fetching reports:', error)
    throw error
  }
}